import React, { Component } from 'react';
import BrowserUtils from '../../../utils/BrowserUtils';

class BasicModal extends Component {
  constructor(props) {
    super(props);

    this.modal = null;

    this.setModalRef = (element) => {
      this.modal = element;
    };

    this.state = {
      displayBlock: false,
    };
  }

  componentDidMount() {
    document.body.classList.add('overflow-hidden');
    if (
      BrowserUtils.isMobileView() &&
      this.modal.clientHeight >= window.innerHeight
    ) {
      this.setState({ displayBlock: true });
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('overflow-hidden');
  }

  render() {
    return (
      <div
        className={`modal-wrapper${
          this.state.displayBlock ? ' display-block' : ''
        }`}
      >
        <div className="modal-wrapper__container" ref={this.setModalRef}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export { BasicModal };
